import React from 'react'
import { Box, Typography } from '@mui/material'
import { Image } from '@media-components'
import { CustomStyles, getStyles } from '@utils/styles'
import { CardData } from '../DefaultCard'
import defaultStyles, { StyleClassNames } from './styles'

export type TechnologyCardData = CardData

export type TechnologyCardProps = TechnologyCardData & {
  csx?: CustomStyles<StyleClassNames>
}

export function TechnologyCard({ imageData, title, csx }: TechnologyCardProps) {
  const styles = getStyles(defaultStyles, csx)

  return (
    <Box {...styles('wrapper')}>
      {imageData && <Image {...imageData} {...styles('image')} />}
      <Typography
        variant="body1.400"
        color="text.primaryDark"
        {...styles('title')}
      >
        {title}
      </Typography>
    </Box>
  )
}
